import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import { Button } from '@material-ui/core';
import {
  getNextAction,
  addAction,
  editAction,
  deleteAction
} from '../../actions/action';
import DatePicker from 'react-date-picker';
import { makeStyles, Link } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import moment from 'moment';

const initialState = {
  name: '',
  time: ''
};

const ViewAction = ({
  getNextAction,
  addAction,
  editAction,
  deleteAction,
  contact: { action },
  contactID
}) => {
  const useStyles = makeStyles(theme => ({
    root: {
      margin: '1em 0 1em 0',
      color: '#333'
    },
    body: {},
    actionBody: {
      padding: '5px',
      background: '#CEEFFF',
      marginBottom: '10px'
    },
    naDiv: {
      display: 'flex'
    },
    naName: {
      width: '10%'
    },
    deleteIcon: {
      marginLeft: '86%'
    },
    pulsIcon: {
      marginLeft: '97%'
    },
    editIcon: {
      marginLeft: '1%'
    },
    newActionBody: {
      padding: '5px',
      background: '#F2F4F4'
    },
    actionNameHead: {
      //fontSize: '1.5rem'
    }
  }));

  const classes = useStyles();
  const [clicked, setClicked] = useState(false);
  const [clickEdit, setClickEdit] = useState(false);

  const onClickDelete = action => {
    deleteAction(action.action, action.action._id);
  };

  const onClick = e => {
    e.preventDefault();
    setClicked(true);
  };

  const onClickEdit = e => {
    e.preventDefault();
    setClickEdit(true);
  };

  const onClickCancel = e => {
    e.preventDefault();
    setClicked(false);
  };

  const onClickEditCancel = e => {
    e.preventDefault();
    setClickEdit(false);
  };

  const [formData, setFormData] = useState(initialState);
  const [formDataNew, setFormDataNew] = useState({
    nameNew: '',
    timeNew: ''
  });

  const { name } = formData;
  const { nameNew } = formDataNew;

  const [timeValue, onChange] = useState(new Date());

  const onChangeInput = e =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onChangeInputNew = e =>
    setFormDataNew({ ...formDataNew, [e.target.name]: e.target.value });

  const onSubmit = e => {
    e.preventDefault();
    let difference = moment().diff(moment(timeValue), 'seconds');
    if (difference < 0) {
      formDataNew.timeNew = timeValue;
      addAction(formDataNew, contactID);
    }
    setClicked(false);
  };

  const onSubmitEdit = e => {
    e.preventDefault();
    let difference = moment().diff(moment(timeValue), 'seconds');
    if (difference < 0) {
      formData.contactID = action.contact;
      formData.time = timeValue;
      editAction(formData, action._id);
    }
    setClickEdit(false);
  };

  useEffect(() => {
    if (!action) getNextAction(contactID);
    if (action) {
      const actionData = { ...initialState };
      for (const key in action) {
        if (key in actionData) actionData[key] = action[key];
      }
      setFormData(actionData);
    }
  }, [getNextAction, contactID, action]);

  return (
    <div className={classes.root}>
      <div className={classes.body}>
        <div>
          {' '}
          {action && action && (
            <Fragment>
              <Fragment>
                <div className={classes.actionBody}>
                  <div className={classes.naDiv}>
                    <div className={classes.naName}>
                      <small>Next Action</small>
                    </div>
                    <div className={classes.deleteIcon}>
                      <Icon
                        className='fas fa-trash-alt'
                        style={{ color: '#0BA5EC', fontSize: 15 }}
                        onClick={e => onClickDelete({ action })}
                      ></Icon>
                    </div>
                    <div className={classes.editIcon}>
                      {clickEdit ? (
                        <Icon
                          className='fas fa-times'
                          style={{ color: '#0BA5EC', fontSize: 15 }}
                          onClick={e => onClickEditCancel(e)}
                        ></Icon>
                      ) : (
                        <Icon
                          className='fas fa-pen'
                          style={{ color: '#0BA5EC', fontSize: 15 }}
                          onClick={e => onClickEdit(e)}
                        ></Icon>
                      )}
                    </div>
                  </div>
                  {clickEdit ? (
                    <Fragment>
                      <div>
                        <h3>Edit Action</h3>{' '}
                        <small>{moment(action.time).format('ll')}</small>
                        <div>
                          <DatePicker
                            required
                            onChange={onChange}
                            value={timeValue}
                          />
                        </div>
                        <form
                          className='na-form'
                          onSubmit={e => onSubmitEdit(e)}
                        >
                          <div className='form-group'>
                            <input
                              type='text'
                              placeholder='Action'
                              name='name'
                              value={name}
                              onChange={e => onChangeInput(e)}
                              required
                            />
                          </div>
                          <input
                            type='submit'
                            className='btn btn-firm'
                            value='Save'
                          />
                          <Link href='#' onClick={e => onClickEditCancel(e)}>
                            Cancel
                          </Link>
                        </form>
                      </div>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <div>
                        <h3 className={classes.actionNameHead}>
                          {action.name}
                        </h3>
                        <small>{moment(action.time).format('ll')}</small>
                      </div>
                      <div className={classes.pulsIcon}>
                        <Icon
                          className='fas fa-plus-circle'
                          style={{ color: '#0BA5EC' }}
                          fontSize='small'
                          onClick={e => onClick(e)}
                        ></Icon>
                      </div>
                    </Fragment>
                  )}
                </div>
              </Fragment>

              {clicked && (
                <div className={classes.newActionBody}>
                  <h3>New Action</h3>{' '}
                  <div>
                    <DatePicker onChange={onChange} value={timeValue} />
                  </div>
                  <form className='na-form' onSubmit={e => onSubmit(e)}>
                    <div className='form-group'>
                      <input
                        type='text'
                        placeholder='Action'
                        name='nameNew'
                        value={nameNew}
                        onChange={e => onChangeInputNew(e)}
                        required
                      />
                    </div>
                    <input
                      type='submit'
                      className='btn btn-firm'
                      value='Save'
                    />
                    <Link href='#' onClick={e => onClickCancel(e)}>
                      Cancel
                    </Link>
                  </form>
                </div>
              )}
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

ViewAction.propTypes = {
  addAction: PropTypes.func.isRequired,
  editAction: PropTypes.func.isRequired,
  deleteAction: PropTypes.func.isRequired,
  getNextAction: PropTypes.func.isRequired,
  contact: PropTypes.object.isRequired,
  contactID: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  contact: state.contact
});

export default connect(mapStateToProps, {
  getNextAction,
  addAction,
  editAction,
  deleteAction
})(ViewAction);



// WEBPACK FOOTER //
// ./src/components/actionStream/ViewAction.js